import React from 'react';
import Sorting from '../../views/Sorting';
import '../../css/regokas.css';
import _ from 'lodash';
import Loader from '../../components/loader';
import Edit from '../../images/headericon/Edit.svg';
import Delete from '../../images/headericon/Delete.svg';
import Success from '../../images/Success.svg';
import Error from '../../images/Error.svg';
import Delete1 from '../../images/headericon/deletedeactive.svg';
import errorText from '../../errorText';
import SearchBar from '../../views/SearchBar';
import cities from './cities';
import Style from 'style-it';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TextField, MenuItem, Input } from "@mui/material";
import { connect } from 'react-redux';
import * as ActionTypes from '../../actions/types';
import { RxCross2 } from 'react-icons/rx';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { AiOutlinePlus } from "react-icons/ai";
import styled from 'styled-components';

import {
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    IconButton,
} from "@mui/material";
import { Box } from '@mui/system';
import { is_allowed } from '../../utils';

const typeOptions = [
    { value: 1, label: 'Type 1' },
    { value: 'type2', label: 'Type 2' },
    { value: 'type3', label: 'Type 3' },
];

const ratingOptions = [
    { value: 'A+', label: 'A+' },
    { value: 'A', label: 'A' },
    { value: 'B+', label: 'B+' },
    { value: 'B', label: 'B' },
    { value: 'C+', label: 'C+' },
    { value: 'C', label: 'C' },
];

const relationstatusOptions = [
    { value: 'Active', label: 'Active' },
    { value: 'Inactive', label: 'Inactive' },
    { value: 'Hold', label: 'Hold' },
];


const ResponsiveTable = styled.div`
  @media only screen and (max-width: 760px) {
    td:nth-of-type(1)::before { content: "S.NO"; }
    td:nth-of-type(2)::before { content: "NAME"; }
    td:nth-of-type(3)::before { content: "PHONE"; }
    td:nth-of-type(4)::before { content: "EMAIL"; }
    td:nth-of-type(5)::before { content: "AREA"; }
    td:nth-of-type(6)::before { content: "TOTAL INVENTORY"; }
    td:nth-of-type(7)::before { content: "ASSIGNED INVENTORY"; }
    td:nth-of-type(8)::before { content: "UNASSIGNED INVENTORY"; }
    td:nth-of-type(9)::before { content: "EDIT"; }
    td:nth-of-type(10)::before { content: "DELETE"; }
  }
`;

class SystemIntegratorAddPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isUpdate: false,
            okasBoxData: [],
            okasBoxDataa: [],
            siData: [],
            siBoxData: [],
            okasBoxDatalocation: [],
            kk: 'asdvhj',
            // password: '',
            si_name: '',
            si_email: '',
            si_mobile: '',
            si_company: '',
            si_address: '',
            si_area: '',
            si_description: '',
            si_rating: '',
            si_relationstatus: '',
            si_gstin: '',
            si_type: 1,

            error: '',
            nameerror: '',
            namess: '',
            sortedType: '',
            searchValue: '',
            actualdata: [],
            disabledvalue: '',
            successmsgmodaldata: localStorage.getItem('dataadded'),
            showmodels: '',
            showmodels1: '',
            loader: '',
            passwordi: false,
            currentPage: 1,
            todosPerPage: 10,
            totalOkasBoxData: [],
            statuson: false, statustw: false, statusth: false,
            statusfo: false, statusfi: false, statussi: false,
            statusse: false, statusei: false, statusni: false,
            statuste: false,
            disableAddButton: false,
            confirmWindow: false,
            projectManagerToDelete: '',
            pagemode: ''

        };
        this.handleClickpage = this.handleClickpage.bind(this);
    }



    crosserrorfullmsg = () => {
        localStorage.removeItem('dataadded');
        this.setState({
            error: '',
        })

    }

    confirmWindowClose = () => {
        this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);

        this.setState({
            confirmWindow: false
        })
    }

    oncolseClickHandler = (event) => {
        this.setState({
            si_name: '',
            si_mobile: '',
            si_email: '',
            si_company: '',
            si_address: '',
            si_area: '',
            si_description: '',
            si_rating: '',
            si_relationstatus: '',
            si_gstin: '',
            si_type: 1,
        })
        this.onclosemodel1()


    }

    componentWillMount() {
    }

    errormsg = () => {
        setTimeout(
            function () {
                localStorage.removeItem('dataadded');
                this.setState({
                    successmsgmodaldata: '',
                    error: '',
                })
            }
                .bind(this), 3000
        );
    }

    crosssuccessfullmsg = () => {
        localStorage.removeItem('dataadded');
        this.setState({
            successmsgmodaldata: '',
        })
    }


    filterLastMonthData(data) {
        // Get the current date and set to the first day of the current month
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth();
        const currentYear = currentDate.getFullYear();

        // Determine the last month and its year
        const lastMonth = currentMonth === 0 ? 11 : currentMonth - 1;
        const lastMonthYear = currentMonth === 0 ? currentYear - 1 : currentYear;

        // Start and end dates for the last month
        const startOfLastMonth = new Date(lastMonthYear, lastMonth, 1);
        const endOfLastMonth = new Date(lastMonthYear, lastMonth + 1, 0, 23, 59, 59);

        // Filter the data by assigned_at date within last month
        return Array.isArray(data)
            ? data.filter(item => {
                const assignedDate = new Date(item.assigned_at);
                return assignedDate >= startOfLastMonth && assignedDate <= endOfLastMonth;
            })
            : [];

    }

    componentDidMount() {

        this.getallrealdata();
        let cityNew = [];
        cities.map((e) => {
            let newCity = {
                "label": `${e.city}, ${e.state}`
            }
            cityNew.push(newCity);
        })
        this.setState({
            indianCityWithState: cityNew
        }, () => console.log(this.state.indianCityWithState))


        const searchParams = new URLSearchParams(window.location.search);
        const modal = searchParams.get("modal"); // Get the `id` query parameter
        const modal2 = searchParams.get("modal2");
        const si_id = searchParams.get("si_id")

        if (modal === "true") {
            this.onopenmodel()
        } else {
            console.warn("No ID provided in the URL. Cannot fetch specific data.");
        }


        if (modal2 === "true") {
            this.onEditButtonClickHandler(si_id)
        } else {
            console.warn("No ID provided in the URL. Cannot fetch specific data.");
        }

    }

    getallrealdata = () => {
        this.setState({
            loader: true,
        })
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }
        fetch('/we/we/addSI/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(siData => {
                const params = new URLSearchParams(window.location.search)
                const filter = params.get("filter")
                // const allIndices = siData.si_data.map((item, index) => index);
                if (filter === "lastMonth") {
                    const filteredSiData = this.filterLastMonthData(Array.isArray(siData.si_data) ? siData.si_data : []);
                    this.setState({
                        okasBoxData: filteredSiData,
                        siBoxData: this.filterLastMonthData(siData.si_box),
                        actualdata: filteredSiData
                    }, () => {
                        this.renderTableData();
                        // console.log(this.state.okasInventoryData)
                    })
                } else {
                    const siDataArray = Array.isArray(siData.si_data) ? siData.si_data : [];
                    this.setState({
                        // siData,
                        okasBoxData: siDataArray,
                        siBoxData: siData.si_box || {},
                        actualdata: siDataArray
                    }, () => {
                        this.renderTableData();
                        // console.log("ADDSI_DATA",this.state.okasBoxData); 
                        // console.log("SI_DATA",this.state.siBoxData); 



                    })

                }



                this.setState({
                    loader: false,

                })


            })


        // fetch('/we/we/locationApi/', {
        //     method: "GET",
        //     headers: headers
        // })
        //     .then(response => response.json())

        //     .then(okasBoxDatalocation => {
        //         this.setState({
        //             okasBoxDatalocation
        //         }, () => {
        //             this.renderTableDatalocation();
        //             this.renderLocation();
        //             console.log(this.state.okasBoxDatalocation);
        //         })
        //     })
    }



    renderTableDatalocation = (type) => {
        if (type === 'location') {
            var typee = 0;
            let xx = this.state.okasBoxDatalocation.map((e, index) => {
                // console.log(e)
                typee = typee + 1;
                return (
                    <option key={index} value={e.ID}>{e.location}</option>
                )
            });
            return xx;
        }
    }

    // renderLocation = () => {
    //     let LocationData = [];
    //     this.state.okasBoxDatalocation.forEach((e) => {
    //         LocationData.push({
    //             label: e.location,
    //             value: e.ID.toString()
    //         })
    //     })
    //     this.setState({
    //         LocationData: LocationData
    //     })
    // }

    renderLocation = () => {
        let LocationData = [];
        if (Array.isArray(this.state.okasBoxDatalocation)) {
            this.state.okasBoxDatalocation.forEach((e) => {
                LocationData.push({
                    label: e.location,
                    value: e.ID.toString()
                });
            });
            this.setState({
                LocationData: LocationData
            });
        } else {
            return null;
        }
    }



    changepasswordmodal = (pmid123, pmname123) => {
        this.setState({
            pmid: pmid123,
            pmname: pmname123
        })
        this.onopenmodel1()
    }



    handleClickpage(event, position) {
        let pageNo = 0;
        if (position === 'position') {
            pageNo = event
        } else {
            pageNo = event.target.id
        }
        this.setState({
            currentPage: Number(pageNo)
        });
        this.renderTableData('type1');
        this.renderTableData('pagination');
    }




    renderTableData = (type) => {
        const okasBoxData = Array.isArray(this.state.okasBoxData) ? this.state.okasBoxData : [];
        if (this.state.okasBoxData && typeof this.state.okasBoxData === 'object' && this.state.okasBoxData.detail == 'Invalid token.') {
            localStorage.removeItem('auth');
            localStorage.removeItem('username');
            this.props.history.push('/login')
        }

        let indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
        let indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
        let currentTodos = okasBoxData.slice(indexOfFirstTodo, indexOfLastTodo);

        if (type === 'pagination') {
            let pageNumbers = [];
            for (let i = 1; i <= Math.ceil(okasBoxData.length / this.state.todosPerPage); i++) {
                pageNumbers.push(i);
            }
            let renderPageNumbers = pageNumbers.map((number, i) => {
                if ((this.state.currentPage - 3 < i + 1) && ((this.state.currentPage + 3 > i + 1 || 6 > i + 1))) {
                    return (
                        <li className={this.state.currentPage == number ? "active" : null}><a id={number} onClick={this.handleClickpage}>{number}</a></li>
                    );
                }
            });
            return renderPageNumbers;
        }

        if (type === '1') {
            var typee = 0;
            let xx = currentTodos.map((e, index) => {
                const correspondingSiBoxInventory = this.state.siBoxData[e.si_email];
                const boxNumber = correspondingSiBoxInventory ? correspondingSiBoxInventory : '0';
                typee = typee + 1;
                let siId = e.si_id;
                // let pmid = e.id;
                // let pmname = e.first_name;
                return (
                    <tr key={index}>
                        <td className={this.props.windowWidth > 760 ? "qwerty" : ""}>{(this.state.currentPage * this.state.todosPerPage) - this.state.todosPerPage + index + 1}</td>
                        {/* <td>{e.id}</td> */}
                        <td>{e.si_name}</td>
                        <td >{e.si_mobile}</td>
                        <td>{e.si_email}</td>
                        <td>{e.si_area}</td>
                        <td style={{ textAlign: 'center' }}>{(e.assigned + e.unassigned) || 0}</td>
                        <td style={{ textAlign: 'center' }}>{(e.assigned) || 0}</td>
                        <td style={{ textAlign: 'center' }}>{(e.unassigned) || 0}</td>

                        {is_allowed(this.props.redux.permissions.permissions?.[0], localStorage.getItem("name"), "system integrator", "edit") && <td style={{ textAlign: 'center' }} className={this.props.windowWidth > 760 ? "qwerty" : ""}><a data-toggle="modal" data-target="#myModal" onClick={this.onEditButtonClickHandler.bind(this, siId)} ><img src={Edit} /></a></td>}


                        {is_allowed(
                            this.props.redux.permissions.permissions?.[0],
                            localStorage.getItem("name"),
                            "system integrator",
                            "delete"
                        ) && (
                                boxNumber == 0 ? (
                                    <td style={{ textAlign: 'center' }} className={this.props.windowWidth > 760 ? "qwerty" : ""}>
                                        <img
                                            src={Delete}
                                            onClick={(e) => {
                                                this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);
                                                this.setState({
                                                    confirmWindow: true,
                                                    si_id: siId
                                                });
                                            }}
                                            style={{ cursor: 'pointer' }}
                                        />
                                    </td>
                                ) : (
                                    <td style={{ textAlign: 'center' }} className={this.props.windowWidth > 760 ? "qwerty" : ""}>
                                        <img
                                            data-toggle="tooltip"
                                            title="Assigned"
                                            src={Delete1}
                                        />
                                    </td>
                                )
                            )}

                    </tr>
                )
            });
            return xx;
        }
    }

    onEditButtonClickHandler = (si_id, pagemode) => {
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')

        }

        fetch(`/we/we/addSI/?si_id=${si_id}`, {
            method: "GET",
            headers: headers,
        })
            .then(response => response.json())
            .then(data => {


                if (data.si_data) {
                    this.setState({
                        data,
                        si_name: data.si_data[0].si_name,
                        si_mobile: data.si_data[0].si_mobile,
                        si_email: data.si_data[0].si_email,
                        si_company: data.si_data[0].si_company,
                        si_address: data.si_data[0].si_address,
                        si_area: data.si_data[0].si_area,
                        si_description: data.si_data[0].si_description,
                        si_rating: data.si_data[0].si_rating,
                        si_relationstatus: data.si_data[0].si_relationstatus,
                        si_gstin: data.si_data[0].si_gstin,
                        si_type: data.si_data[0].si_type,
                        si_id: data.si_data[0].si_id,
                        showmodels: 'true',
                        pagemode: 'edit',

                    });
                    this.onopenmodelEdit();

                }

            });
    }



    onEditSaveHandler = (buttonaction, si_id) => {
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')

        }
        let si_name = this.state.si_name.trim();
        let si_email = this.state.si_email.trim();
        let si_mobile = this.state.si_mobile.trim();
        let si_company = this.state.si_company.trim();
        let si_address = this.state.si_address.trim();
        let si_area = this.state.si_area.trim();
        let si_description = this.state.si_description.trim();
        let si_rating = this.state.si_rating.trim();
        let si_relationstatus = this.state.si_relationstatus.trim();
        let si_gstin = this.state.si_gstin.trim();
        let si_type = this.state.si_type.trim();

        let tt = {
            si_name,
            // si_email,  // Email not editable
            si_mobile,
            si_company,
            si_address,
            si_area,
            si_description,
            si_rating,
            si_relationstatus,
            // si_gstin, // GST not editable
            si_type,
        };

        if (si_name.length < 2) {
            this.setState({ nameerror: true });
            toast.error("Please enter valid name.")
        }
        else if (si_mobile.length !== 10) { this.setState({ phoneerror: true }); toast.error("Please enter valid mobile number.") }
        else if (si_email.length === 0) { this.setState({ emailerror: true }); toast.error("Please enter valid email.") }
        else if (si_gstin.length === 0) { this.setState({ gstinerror: true }); toast.error("Please enter valid GSTIN") }
        
        if (!this.state.nameerror && !this.state.phoneerror && !this.state.emailerror && !this.state.gstinerror) {
            this.setState({ disabledvalue: 'disabled' });
            this.setState({ loader: true });

            fetch(`/we/we/addSI/?si_id=${si_id}`, {
                method: "PUT",
                headers: headers,
                body: JSON.stringify(tt)
            })
                .then(response => response.json())
                .then(data => {
                    // console.log("ll", data);
                    this.setState({
                        successmsgmodaldata: 'dataadded',
                        successmodalstates: 'add',
                        disabledvalue: '',
                    })
                    this.getallrealdata();
                    alert('SI Edited Successfully!');
                    this.oncolseClickHandler();
                    this.onclosemodel();
                    this.errormsg();
                    if (buttonaction === 'edit') {
                        this.onclosemodel();
                    }

                    this.setState({
                        loader: true,
                    });

                })
        }
    }


    ondeleteChangeHandler = (si_id) => {
        this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);

        this.setState({
            confirmWindow: true
        })
        if (true) {
            this.setState({
                loader: true,
            })
            let TokenValue = 'Token ' + localStorage.getItem("auth");
            var headers = {
                'Content-Type': 'application/json',
                'Authorization': TokenValue,
                'X-CSRFToken': localStorage.getItem('csrftoken')

            }
            fetch(`/we/we/addSI/?si_id=${si_id}`, {
                method: "DELETE",
                headers: headers,
            })
                .then(response => {
                    console.log(response)
                    if (response.status == 200) {
                        this.setState({
                            successmsgmodaldata: 'dataadded',
                            successmodalstates: 'add',
                            disabledvalue: '',
                        })
                        this.getallrealdata();
                        alert("SI Deleted Successfully")
                        this.confirmWindowClose();
                        this.oncolseClickHandler();
                        this.errormsg();


                    } else {
                        alert('SI can not deleted.');
                    }
                    this.setState({
                        loader: false,
                    })
                })

        }
    }

    onopenmodel = (event) => {
        this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);

        this.setState({
            showmodels: 'true',
            pagemode: ''
        })
        this.props.searchBarActivate(false)
    }

    onopenmodelEdit = (event) => {
        this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);

        this.setState({
            showmodels: 'true',
            pagemode: 'edit'
        })
        this.props.searchBarActivate(false)
    }

    // onclosemodel = (event) => {
    //     const searchParams = new URLSearchParams(window.location.search);
    //     const modal = searchParams.get("modal"); // Get the `id` query parameter
    //     const modal2 = searchParams.get("modal2");

    //     if (modal || modal2) {
    //         window.location.href = "/dashboardnew"
    //     }
    //     this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);

    //     this.setState({
    //         showmodels: '',
    //         error: '',
    //         si_name: '',
    //         si_mobile: '',
    //         si_email: '',
    //         si_company: '',
    //         si_address: '',
    //         si_area: '',
    //         si_description: '',
    //         si_rating: '',
    //         si_relationstatus: '',
    //         si_gstin: '',
    //         si_type: 1,   // Change to hard code
    //         // si_id:'',
    //         // password: '',
    //         nameerror: '',
    //         phoneerror: '',
    //         emailerror: '',
    //         areaerror: '',
    //         addresserror: '',
    //         descriptionerror: '',
    //         ratingerror: '',
    //         companyerror: '',
    //         relationstatuserror: '',
    //         gstinerror: '',
    //         typeerror: '',
    //         // passworderror: '',
    //         disableAddButton: false
    //     })
    // }


    onclosemodel = (event) => {
    const searchParams = new URLSearchParams(window.location.search);
    const modal = searchParams.get("modal");
    const modal2 = searchParams.get("modal2");

    // 🚀 Redirect first before doing any state reset to avoid flickering
    if (modal || modal2) {
        window.location.href = "/dashboardnew";
        return; // ⛔️ Prevent further execution
    }

    // ✅ Only reset state if not redirecting
    if (typeof this.props.backgroundScrollStop === "function") {
        this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);
    }

    this.setState({
        showmodels: '',
        error: '',
        si_name: '',
        si_mobile: '',
        si_email: '',
        si_company: '',
        si_address: '',
        si_area: '',
        si_description: '',
        si_rating: '',
        si_relationstatus: '',
        si_gstin: '',
        si_type: 1,
        nameerror: '',
        phoneerror: '',
        emailerror: '',
        areaerror: '',
        addresserror: '',
        descriptionerror: '',
        ratingerror: '',
        companyerror: '',
        relationstatuserror: '',
        gstinerror: '',
        typeerror: '',
        disableAddButton: false
    });
};



    onopenmodel1 = (event) => {
        this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);
        this.setState({
            showmodels1: 'true',
        })
    }

    onclosemodel1 = (event) => {
        this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);

        this.setState({
            showmodels1: '',
        })
    }

    setpasswordi = (buttonaction) => {
        this.setState({
            passwordi: !this.state.passwordi,
        })
    }

    onAddClickHandler = (buttonaction) => {
        this.setState({
            nameerror: '',
            phoneerror: '',
            emailerror: '',
            areaerror: '',
            addresserror: '',
            descriptionerror: '',
            ratingerror: '',
            companyerror: '',
            relationstatuserror: '',
            gstinerror: '',
            // passworderror: '',
            disableAddButton: true,
        })


        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken'),
        }

        // let password = this.state.password.trim();
        let si_name = this.state.si_name.trim();
        let si_email = this.state.si_email.trim();
        let si_mobile = this.state.si_mobile.trim();
        let si_company = this.state.si_company.trim();
        let si_address = this.state.si_address.trim();
        let si_area = this.state.si_area.trim();
        let si_description = this.state.si_description.trim();
        let si_rating = this.state.si_rating.trim();
        let si_relationstatus = this.state.si_relationstatus.trim();
        let si_gstin = this.state.si_gstin.trim();
        let si_type = this.state.si_type;
        // let office_location = this.state.officeLocation.trim();
        let emailidexist = _.filter(this.state.okasBoxData, { si_email });
        let phonenoexist = _.filter(this.state.okasBoxData, { si_mobile });
        let tt = {
            // password,
            si_name,
            si_email,
            si_mobile,
            si_company,
            si_address,
            si_area,
            si_description,
            si_rating,
            si_relationstatus,
            si_gstin,
            si_type,
            // office_location,
        };


        if (si_name.length < 2 || /[@~!#$%^&*(){}[\]]/.test(si_name)) {
            this.setState({ nameerror: true });
            toast.error("Please enter a valid name.");
        }
        else if (si_mobile.length !== 10) { this.setState({ phoneerror: true }); toast.error("Please enter valid mobile number.") }
        else if (!/^[6-9]\d{9}$/.test(si_mobile)) {
            this.setState({ phoneerror: true });
            toast.error("Please enter a valid Indian mobile number (starting with 6/7/8/9)");
        }

        else if (si_email.length === 0) { this.setState({ emailerror: true }); toast.error("Please enter valid email.") }
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(si_email)) {
            this.setState({ emailerror: true });
            toast.error("Please enter a valid email format (e.g., user@example.com).");
        }
        else if (si_gstin.length === 0) { this.setState({ gstinerror: true }); toast.error("Please enter valid GSTIN.") }
        // gst extra
        else if (!si_gstin || typeof si_gstin !== "string" || si_gstin.length === 0) {
            this.setState({ gstinerror: true });
            toast.error("Please enter a valid GSTIN.");
        }
        else if (!/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/.test(si_gstin)) {
            this.setState({ gstinerror: true });
            toast.error("Please enter a valid GSTIN.");
        }
        else if (si_area.trim() === "") {
            this.setState({ areaerror: true });
            toast.error("Please select an area.");
        }
        else if (si_address.trim() === "") {
            this.setState({ areaerror: true });
            toast.error("Please enter a valid address.");
        }
        else if (si_company.trim() === "") {
            this.setState({ companyerror: true });
            toast.error("Please enter a company name.");
        }

        // gst extra
        else if (!this.state.nameerror && !this.state.phoneerror && !this.state.emailerror && !this.state.gstinerror && !this.state.areaerror && !this.state.companyerror && !this.state.areaerror) {
            this.setState({ disabledvalue: 'disabled' });
            this.setState({ loader: true });

            fetch('/we/we/addSI/', {
                method: "POST",
                headers: headers,
                body: JSON.stringify(tt)
            })
                .then(response => response.json())
                .then(data => {
                    // Handle the successful response here
                    // console.log(data);
                    if (data.message === "success") {
                        this.setState({
                            successmsgmodaldata: 'dataadded',
                            successmodalstates: 'add',
                            disabledvalue: '',
                        });
                        this.getallrealdata();
                        alert('SI Added Successfully!');
                        this.onclosemodel();
                        this.oncolseClickHandler();
                        this.errormsg();
                        if (buttonaction === 'add') {
                            this.onclosemodel();
                        } else if (buttonaction === 'addanother') {
                            this.setState({
                                showmodels: 'true',
                                error: '',
                                si_name: '',
                                si_mobile: '',
                                si_email: '',
                                si_company: '',
                                si_address: '',
                                si_area: '',
                                si_description: '',
                                si_rating: '',
                                si_relationstatus: '',
                                si_gstin: '',
                                si_type: 1,
                                // password: '',
                                // officeLocation: ''
                            });
                        }

                    } else {
                        this.setState({ disabledvalue: '' });
                        this.setState({ loader: false });
                        // console.log("Data received:", data.data);
                        alert(Object.values(data.data));

                        return null;

                    }
                    this.setState({
                        loader: false,
                    });
                })
        }
    }

    restoreData = (data) => {
        this.setState({
            okasBoxData: Array.isArray(data) ? data : [],
        })
    }


    sortingFunc = (type, searchValue) => {


        if (type !== "search") {
            this.props.searchBarActivate(false)
        }

        if (type == "si_name") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statuson: !this.state.statuson,
            })
        }
        if (type == "si_type") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statuson: !this.state.statuson,
            })
        }
        if (type == "si_mobile") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statustw: !this.state.statustw,
            })
        }
        if (type == "si_email") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statusth: !this.state.statusth,
            })
        }
        if (type == "si_company") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statusth: !this.state.statusth,
            })
        }
        if (type == "si_address") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statusth: !this.state.statusth,
            })
        }
        if (type == "si_area") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statusth: !this.state.statusth,
            })
        }
        if (type == "si_description") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statusth: !this.state.statusth,
            })
        } if (type == "si_rating") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statusth: !this.state.statusth,
            })
        } if (type == "si_relationstatus") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statusth: !this.state.statusth,
            })
        } if (type == "si_gstin") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statusth: !this.state.statusth,
            })
        }
        if (type == "si_id") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statussi: !this.state.statussi,
            })
        }


        if (this.state.sortedType !== type && type !== 'search') {
            this.setState({
                sortedType: type
            })
            Sorting(this.restoreData, type, this.state.okasBoxData);
        } else if (type === 'search') {
            type = 'search';
            Sorting(this.restoreData, type, this.state.actualdata, searchValue);
        } else {
            type = 'reverse';
            Sorting(this.restoreData, type, this.state.okasBoxData);
        }
    }

    onSelectChange = (operationMode, valueSelect) => {
        if (valueSelect.label !== undefined) {
            this.setState({
                [operationMode]: valueSelect.value,
                error: false,
                locationerror: false,
            })

        }

    }

    render() {

        const { isUpdate } = this.props;

        // const { isUpdate, si_email, emailerror } = this.state;
        return (<ResponsiveTable> <div>
            <ToastContainer />
            <div className="selfcontainer"
                style={{
                    position: !this.props.redux.globalVar.backgroundScrollStop && this.props.windowWidth < 760 ? "fixed" : "absolute",
                    overflow: !this.props.redux.globalVar.backgroundScrollStop && this.props.windowWidth < 760 ? "hidden" : "",

                }}

            >
                <ToastContainer />
                {this.state.loader ? <Loader /> : null}

                {this.props.redux.globalVar.searchBarShow ?
                    <div className='row searchinput'>
                        <SearchBar
                            autoFocus
                            value={this.state.searchValue}
                            onChange={(e) => {
                                this.setState({
                                    searchValue: e
                                }, () => {
                                    this.sortingFunc('search', this.state.searchValue)
                                })
                            }
                            }
                            onRequestSearch={() => this.sortingFunc('search', this.state.searchValue)}
                            resetSearch={(e) => {
                                this.setState({
                                    searchValue: e
                                }, () => {
                                    this.sortingFunc('search', '')
                                })
                            }}
                        />
                    </div>
                    : ''}
                <div className="addregOkasButton" >
                    {is_allowed(this.props.redux.permissions.permissions?.[0], localStorage.getItem("name"), "system integrator", "add") &&
                        <Box
                            component="a"
                            // href="#myModal"
                            className="addregOkasButtonicon button-custom-height-size"
                            onClick={this.onopenmodel.bind(this)}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                backgroundColor: "#f9f9f9",
                                color: "#94979a",
                                textTransform: "none",
                                padding: "10px 20px",
                            }}
                        >
                            <AiOutlinePlus size={30} style={{ marginRight: 8, color: "#15599F" }} />
                            <span className="hidden-xs hidden-sm button-color">ADD SYSTEM INTEGRATOR</span>
                        </Box>
                    }
                    <div className="hidden-xs hidden-md  hidden-lg button-color sm-heading-btn">Add SYSTEM INTEGRATOR</div>

                </div>
                <div className="row" onContextMenu={(e) => { e.preventDefault(); }}>
                    <h3>Dear {this.props.redux.globalVar.reUserNameStyle}, Listed below are your existing System Integrator</h3>
                    <h6 className="mb-3 mt-0">To add a new System Integrator click on, "Add System Integrator" </h6>
                    <div className={this.state.successmsgmodaldata ? 'successmsgbox' : 'successmsgbox successmsgboxnone'}  >
                        <div className="inblksuccfull"><img src={Success} /></div>
                        <div className="inblksucc1">
                            SUCCESS !
                            <a className="successmsgcross"><RxCross2 size={20} onClick={(e) => { this.crosserrorfullmsg(this) }} /></a>
                        </div>
                    </div>

                    <div className="tests">
                        <TableContainer component={Paper} className={this.props.windowWidth > 760 ? "table table-striped tablecontent" : "mobile-device-margin-zero"}>
                            <Table className={"tablecontent"}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ color: 'white', fontSize: '11px' }}>S.NO</TableCell>
                                        <TableCell sx={{ color: 'white', fontSize: '11px' }}>
                                            NAME
                                            {this.props.statuson ? (
                                                <IoIosArrowUp style={{ color: 'white' }} size={16} className="pull-right" onClick={() => this.sortingFunc('si_name', '')} />
                                            ) : (
                                                <IoIosArrowDown style={{ color: 'white' }} size={16} className="pull-right" onClick={() => this.sortingFunc('si_name', '')} />
                                            )}
                                        </TableCell>
                                        <TableCell sx={{ color: 'white', fontSize: '11px' }}>
                                            PHONE
                                            {this.props.statustw ? (
                                                <IoIosArrowUp style={{ color: 'white' }} size={16} className="pull-right" onClick={() => this.sortingFunc('si_mobile', '')} />
                                            ) : (
                                                <IoIosArrowDown style={{ color: 'white' }} size={16} className="pull-right" onClick={() => this.sortingFunc('si_mobile', '')} />
                                            )}
                                        </TableCell>
                                        <TableCell sx={{ color: 'white', fontSize: '11px' }}>
                                            EMAIL
                                            {this.props.statusth ? (
                                                <IoIosArrowUp style={{ color: 'white' }} size={16} className="pull-right" onClick={() => this.sortingFunc('si_email', '')} />
                                            ) : (
                                                <IoIosArrowDown style={{ color: 'white' }} size={16} className="pull-right" onClick={() => this.sortingFunc('si_email', '')} />
                                            )}
                                        </TableCell>
                                        <TableCell sx={{ color: 'white', fontSize: '11px' }}>
                                            AREA
                                            {this.props.statusfo ? (
                                                <IoIosArrowUp style={{ color: 'white' }} size={16} className="pull-right" onClick={() => this.sortingFunc('si_area', '')} />
                                            ) : (
                                                <IoIosArrowDown style={{ color: 'white' }} size={16} className="pull-right" onClick={() => this.sortingFunc('si_area', '')} />
                                            )}
                                        </TableCell>
                                        <TableCell sx={{ color: 'white', fontSize: '11px', width: '80px', minWidth: '80px', maxWidth: '80px' }}>TOTAL INVENTORY</TableCell>
                                        <TableCell sx={{ color: 'white', fontSize: '11px', width: '80px', minWidth: '80px', maxWidth: '80px' }}>ASSIGNED PROJECT</TableCell>
                                        <TableCell sx={{ color: 'white', fontSize: '11px', width: '80px', minWidth: '80px', maxWidth: '80px', }}>UNASSIGNED INVENTORY</TableCell>
                                        {is_allowed(this.props.redux.permissions.permissions?.[0], localStorage.getItem("name"), "system integrator", "edit") && <TableCell sx={{ color: 'white', fontSize: '11px' }}>EDIT</TableCell>}
                                        {is_allowed(this.props.redux.permissions.permissions?.[0], localStorage.getItem("name"), "system integrator", "delete") && <TableCell sx={{ color: 'white', fontSize: '11px' }}>DELETE</TableCell>}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.renderTableData("1")}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <div className="pull-right">
                            {this.state.todosPerPage < (Array.isArray(this.state.okasBoxData) ? this.state.okasBoxData.length : 0) ?
                                <ul className="pagination pull-right paginat">

                                    <li>
                                        <span className="">Showing {(this.state.currentPage * this.state.todosPerPage) - this.state.todosPerPage + 1} -{this.state.currentPage * this.state.todosPerPage - (Array.isArray(this.state.okasBoxData) ? this.state.okasBoxData.length : 0) < 0 ? this.state.currentPage * this.state.todosPerPage : (Array.isArray(this.state.okasBoxData) ? this.state.okasBoxData.length : 0)}  of {Array.isArray(this.state.okasBoxData) ? this.state.okasBoxData.length : 0} enteries</span>
                                    </li>

                                    <li>
                                        <a
                                            style={{ pointerEvents: this.state.currentPage === 1 ? 'none' : '' }}
                                            onClick={this.state.currentPage == -1 + this.state.currentPage * this.state.todosPerPage ? null :
                                                this.handleClickpage.bind(this, this.state.currentPage - 1, 'position')
                                            }
                                            aria-label="Previous">
                                            <span aria-hidden="true">&laquo;</span>
                                            <span className="sr-only">Previous</span>
                                        </a>
                                    </li>

                                    {this.renderTableData('pagination')}
                                    <li className="">
                                        <a className=""
                                            style={{ pointerEvents: Math.ceil((Array.isArray(this.state.okasBoxData) ? this.state.okasBoxData.length : 0) / this.state.todosPerPage) === Number(this.state.currentPage) ? 'none' : '' }}
                                            onClick={this.state.currentPage * this.state.todosPerPage == (Array.isArray(this.state.okasBoxData) ? this.state.okasBoxData.length : 0) ? null :
                                                this.handleClickpage.bind(this, this.state.currentPage + 1, 'position')
                                            }

                                            aria-label="Next">
                                            <span aria-hidden="true">&raquo;</span>
                                            <span className="sr-only">Next</span>
                                        </a>
                                    </li>
                                </ul>
                                : null}
                        </div>

                    </div> </div>
                {this.state.showmodels ?
                    <div className="selfmodal fade in modal-dialog-centered" id="myModal" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                        <div className="selfmodal-dialog"
                            style={{
                                width: this.props.windowWidth > 760 ? "60%" : "90%",
                            }}
                        >
                            <form action="javascript:void(0)">
                                <div className="selfmodal-content" style={{ margin: 'auto', marginTop: "500px", maxWidth: '70%', }} >
                                    <div className="modal-header">
                                        <button type="button" className="close" data-dismiss="modal" onClick={this.onclosemodel.bind(this)}>&times;</button>
                                        <h3 className="modal-title">
                                            {this.state.pagemode === 'edit' ? 'Edit' : 'Add New'} System Integrator
                                        </h3>
                                        <h6>Please fill in the details to {this.state.pagemode === 'edit' ? 'update' : 'add new'} system integrator.</h6>
                                    </div>
                                    <div className="modal-body modfields modal-body" style={{ paddingTop: '10px' }}>
                                        <div style={{ marginBottom: "30px" }}>
                                            <TextField
                                                label="Name"
                                                type="text"
                                                variant="standard"
                                                name="si_name"
                                                value={this.state.si_name}
                                                onFocus={() => this.setState({ nameerror: false })}
                                                onBlur={() =>
                                                    this.setState({ nameerror: this.state.si_name.trim().length < 1 })
                                                }
                                                onChange={(e) => {
                                                    const input = e.target.value;
                                                    const validInput = input.replace(/[^a-zA-Z ]/g, '').slice(0, 35); // Only letters & space
                                                    this.setState({ si_name: validInput });
                                                }}
                                                onKeyDown={(e) => {
                                                    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', ' '];
                                                    if (
                                                        !allowedKeys.includes(e.key) &&
                                                        !/^[a-zA-Z]$/.test(e.key)
                                                    ) {
                                                        e.preventDefault(); // Block numbers & special characters
                                                    }
                                                }}
                                                onPaste={(e) => {
                                                    const pastedData = e.clipboardData.getData('text');
                                                    if (!/^[a-zA-Z ]+$/.test(pastedData)) {
                                                        e.preventDefault(); // Block pasting invalid input
                                                    }
                                                }}
                                                inputProps={{ maxLength: 35 }}
                                                error={this.state.nameerror}
                                                // helperText={this.state.nameerror ? "Name should not be empty." : ""}
                                                fullWidth
                                            />

                                        </div>
                                        <div style={{ marginBottom: "30px" }}>
                                            {/* <TextField
                                                label="Phone"
                                                type="number"
                                                name="si_mobile"
                                                variant="standard"
                                                inputProps={{ maxLength: 10 }}
                                                value={this.state.si_mobile}
                                                onFocus={() => this.setState({ phoneerror: false })}
                                                onBlur={() => {
                                                    const { si_mobile } = this.state;
                                                    this.setState({
                                                        phoneerror: !(si_mobile.length === 10 && /^[6-9][0-9]{9}$/.test(si_mobile)),
                                                    });
                                                }}
                                                onChange={(e) => {
                                                    if (e.target.value.length > 10) return;
                                                    this.setState({ si_mobile: e.target.value });
                                                }}
                                                error={this.state.phoneerror}
                                                //  helperText={this.state.phoneerror ? "Please enter a valid 10-digit phone number." : ""}
                                                fullWidth
                                                style={{ marginBottom: "5px" }}
                                            /> */}
                                            <TextField
                                                label="Phone"
                                                type="text" // ✅ Change to text for full control
                                                name="si_mobile"
                                                variant="standard"
                                                inputProps={{
                                                    maxLength: 10,
                                                    inputMode: 'numeric', // shows numeric keyboard on mobile
                                                    pattern: "[0-9]*"
                                                }}
                                                value={this.state.si_mobile}
                                                onFocus={() => this.setState({ phoneerror: false })}
                                                onBlur={() => {
                                                    const { si_mobile } = this.state;
                                                    this.setState({
                                                        phoneerror: !(si_mobile.length === 10 && /^[6-9][0-9]{9}$/.test(si_mobile)),
                                                    });
                                                }}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d{0,10}$/.test(value)) {
                                                        this.setState({ si_mobile: value });
                                                    }
                                                }}
                                                error={this.state.phoneerror}
                                                fullWidth
                                                style={{ marginBottom: "5px" }}
                                            />

                                            {this.state.phoneerror && (
                                                <span style={{ color: "red", fontSize: "12px" }}>
                                                    Please enter a valid 10-digit phone number.
                                                </span>
                                            )}
                                        </div>
                                        <div style={{ marginBottom: "30px" }}>
                                            <TextField
                                                label="Email"
                                                type="text"
                                                name="si_email"
                                                // placeholder="Email"
                                                variant="standard" // Only bottom border
                                                value={this.state.si_email}
                                                onFocus={() => this.setState({ emailerror: false })}
                                                onBlur={() => {
                                                    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
                                                    this.setState({ emailerror: !emailRegex.test(this.state.si_email) });
                                                }}
                                                onChange={(e) => this.setState({ si_email: e.target.value })}
                                                error={this.state.emailerror}
                                                //  helperText={this.state.emailerror ? "Please enter a valid email (e.g., example@domain.com)." : ""}
                                                fullWidth

                                                style={{ marginBottom: "5px" }}
                                            />
                                            {this.state.emailerror && (
                                                <span style={{ color: "red", fontSize: "12px" }}>
                                                    Please enter a valid email (e.g., example@domain.com).
                                                </span>
                                            )}
                                        </div>

                                        <div style={{ marginBottom: "30px" }}>
                                            <TextField
                                                label="Company"
                                                type="text"
                                                name="si_company"
                                                // placeholder="Company"
                                                variant="standard" // Only bottom border
                                                value={this.state.si_company}
                                                onChange={(e) => {
                                                    if (e.target.value.length <= 100) {
                                                        this.setState({ si_company: e.target.value, companyerror: false });
                                                    }
                                                }}
                                                fullWidth
                                                style={{ marginBottom: "5px" }}
                                            />
                                        </div>

                                        <div style={{ marginBottom: "30px" }}>
                                            <TextField
                                                label="Address"
                                                type="text"
                                                name="si_address"
                                                // placeholder="Address"
                                                variant="standard" // Only bottom border
                                                value={this.state.si_address}
                                                onChange={(e) => {
                                                    if (e.target.value.length <= 100) {
                                                        this.setState({ si_address: e.target.value, addresserror: false });
                                                    }
                                                }}
                                                fullWidth
                                                //  helperText={this.state.addresserror ? "Please enter a valid address." : ""}
                                                style={{ marginBottom: "5px" }}
                                            />
                                        </div>

                                        <div style={{ marginBottom: "30px" }}>
                                            <TextField
                                                label="Area"
                                                select
                                                fullWidth
                                                variant="standard"
                                                value={this.state.si_area}
                                                onChange={(event) => this.setState({ si_area: event.target.value })} // Inline state update
                                                style={{ marginBottom: "5px" }} // Inline styling applied
                                            >
                                                {this.state.indianCityWithState.map((option, index) => (
                                                    <MenuItem
                                                        key={index}
                                                        value={option.label} // Using label as value
                                                        style={{ fontSize: "14px", padding: "10px 15px" }}
                                                    >
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </div>

                                        <div style={{ marginBottom: "30px" }}>
                                            <TextField
                                                label="Description"
                                                type="text"
                                                name="si_description"
                                                // placeholder="Description"
                                                variant="standard" // Only bottom border
                                                value={this.state.si_description}
                                                onChange={(e) => {
                                                    if (e.target.value.length <= 100) {
                                                        this.setState({ si_description: e.target.value, descriptionerror: false });
                                                    }
                                                }}
                                                fullWidth
                                                style={{ marginBottom: "5px" }}
                                            />
                                        </div>

                                        <div style={{ marginBottom: "30px" }}>
                                            <TextField
                                                label="Rating"
                                                select
                                                fullWidth
                                                variant="standard"
                                                value={this.state.si_rating}
                                                onChange={(event) => this.setState({ si_rating: event.target.value })} // Inline state update

                                                style={{ marginBottom: "5px" }} // Inline styling applied
                                            >
                                                {ratingOptions.map((option) => (
                                                    <MenuItem
                                                        key={option.value}
                                                        value={option.value}
                                                        style={{ fontSize: "14px", padding: "10px 15px" }} // Inline styles for options
                                                    >
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </div>

                                        <div style={{ marginBottom: "30px" }}>
                                            <TextField
                                                label="Relation Status"
                                                select
                                                fullWidth
                                                variant="standard"
                                                value={this.state.si_relationstatus}
                                                onChange={(event) => this.setState({ si_relationstatus: event.target.value })} // Inline state update

                                                style={{ marginBottom: "5px" }} // Inline styling applied
                                            >
                                                {relationstatusOptions.map((option) => (
                                                    <MenuItem
                                                        key={option.value}
                                                        value={option.value}
                                                        style={{ fontSize: "14px", padding: "10px 15px" }} // Inline styles for options
                                                    >
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </div>

                                        <div style={{ marginBottom: "30px" }}>
                                            <TextField
                                                label="GST"
                                                type="text"
                                                name="si_gstin"
                                                variant="standard" // Only bottom border
                                                value={this.state.si_gstin}
                                                onFocus={() => this.setState({ gstinerror: false })}
                                                onBlur={() => {
                                                    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9]{1}$/;
                                                    this.setState({ gstinerror: !gstRegex.test(this.state.si_gstin) });
                                                }}
                                                onChange={(e) => this.setState({ si_gstin: e.target.value })}
                                                error={this.state.gstinerror}
                                                helperText={this.state.gstinerror ? "Please enter a valid GST number." : ""}
                                                fullWidth
                                                style={{ marginBottom: "5px" }}
                                            />
                                        </div>
                                        <br />
                                        <span className="fieldmend"></span>
                                    </div>
                                    <div className="modal-footer align-btn-mobile">
                                        {/* Cancel Button */}
                                        <button type="button" className="btn allbtn" data-dismiss="modal" onClick={this.onclosemodel.bind(this)}>
                                            Cancel
                                        </button>

                                        {/* Conditional Edit or Add Button */}
                                        {this.state.pagemode === "edit" ? (
                                            <button
                                                type="button"
                                                disabled={this.state.disabledvalue || false}
                                                className="btn allbtn"
                                                onClick={() => this.onEditSaveHandler("edit", this.state.si_id)}
                                                style={{ backgroundColor: "#4286f5", marginLeft: "10px" }}

                                            >
                                                Edit
                                            </button>
                                        ) : (
                                            <span>
                                                <button
                                                    type="button"
                                                    disabled={this.state.disabledvalue || false}
                                                    className="btn allbtn"
                                                    onClick={() => this.onAddClickHandler("add")}
                                                    style={{ backgroundColor: "#4286f5", marginLeft: "10px" }}

                                                >
                                                    Add
                                                </button>
                                            </span>
                                        )}
                                    </div>

                                </div>
                            </form>
                        </div>
                    </div>
                    : ''}

                {this.state.confirmWindow ? <div className="selfmodal fade in modal-dialog-centered" aria-hidden="false" data-backdrop="static" data-keyboard="false">
                    <div className="selfmodal-dialog" style={{ width: "50%" }}>
                        <div className="selfmodal-content">
                            <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" onClick={this.confirmWindowClose.bind(this)}>&times;</button>
                                <h4 className="modal-title h3 text-center">Delete Confirmation</h4>
                            </div>
                            <div className="modal-body modfields">
                                <span className="fa " >Are you sure you want to delete SI?</span>
                            </div>
                            <div className="modal-footer text-center align-btn-mobile">
                                <button type="button" className="btn allbtn" onClick={this.confirmWindowClose.bind(this)}>Cancel</button>
                                <button type="submit" disabled={this.state.disabledvalue ? this.state.disabledvalue : null} className="btn btn-primary allbtn" onClick={this.ondeleteChangeHandler.bind(this, this.state.si_id)}>Delete</button>
                            </div>
                        </div>
                    </div>
                </div> : null}
            </div>
        </div>
        </ResponsiveTable>
        );
    }

}

const mapStateToProps = state => {
    return {
        redux: state,
    };
};


const mapDispatchToProps = dispatch => {
    return {
        searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
        searchBarStyleActivate: (data) => dispatch({ type: ActionTypes.SEARCHBARSTYLE, data: data }),
        backgroundScrollStop: (data) => dispatch({ type: ActionTypes.SCROLLSTOP, data: data }),

    };
};


export default connect(mapStateToProps, mapDispatchToProps)(SystemIntegratorAddPage); 